// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export default {
  heading: 'Coordination',
  items: [{
    label: 'How long does the analysis take?',
    details: 'The analysis takes 2-3 business days.',
  }, {
    label: 'When will my path(s) be off coordination?',
    details: 'The standard PCN period is 30 days. Once that period is fulfilled and any cases have been resolved the path can be filed.',
  }, {
    label: 'Is it possible to shorten the PCN period?',
    details: 'Yes. A PCN period can be shortened to 14 days upon request.',
  }, {
    label: 'What is Conditional Authorization?',
    details: 'Conditional Authorization allows some paths to operate as soon as the FCC applications have been submitted.',
  }, {
    label: 'What is a quiet zone and how do I know if my path is in one?',
    details: 'Restricted areas due to military or radio astronomy.',
  }, {
    label: 'When can I order my equipment?',
    details: 'You can order your equipment once the PCN period is fulfilled and all cases are resolved.',
  }, {
    label: 'What is a "Completion of Construction Notice" or "Schedule K"?',
    details: 'The FCC requires you to construct and operate within 18 months of a license grant date. Once constructed,' +
    'you must file a Schedule K notice—providing the construction date. Failure to file this notice will result in termination of the licenses.',
  }, {
    label: 'How long to I have to construct my path(s)?',
    details: '18 months from the license grant date.',
  }, {
    label: 'When can I turn up my new path?',
    details: 'If your path is not eligible for conditional authorization you cannot operate until the licenses are granted.',
  }, {
    label: 'How long is a PCN valid?',
    details: 'A PCN is good for six months. At the end of the six month period you must either renew the PCN or file with the FCC.',
  }],
}
